import {
  Autocomplete,
  ListItemText,
  MenuItem,
  TableCell,
  TableRow,
  TextField,
  Checkbox,
  IconButton,
  Tooltip,
  Box,
  Paper,
  InputAdornment,
} from '@mui/material';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import TreeDropdown from '../../../components/DropDown/CategoryDropDown';
import { grey } from '@mui/material/colors';
import { Edit, Settings, Tab } from '@mui/icons-material';
import Add from '@mui/icons-material/Add';
import { MoneyFormatv3 } from '../../../library/MoneyFormat';
import Close from '@mui/icons-material/Close';
import Done from '@mui/icons-material/Done';
import { API, graphqlOperation } from 'aws-amplify';
import { AddBox } from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import { createItemTransaction, listGeneralSetting, listVoucherSerialNumbers } from '../../../graphql';
import { showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { createItemAmountDetailsArray } from '../../../graphql/mutations';
import { styled } from '@mui/material/styles';
import PriceModal from './PriceModal';
import AddItemsAccountModal from '../Modals/AddItemsAccountModal';
import AddUnitsModal from '../../../components/modals/AddUnits';
import { useThemes } from '../../../components/Theme/theme';
import { getCompanyCodeTranslationApi, useGetCompanyCodeTranslationQuery } from '../../../redux/apis/getCompanyCodeTranslation.api';
import { useGetCodeTranslationQuery } from '../../../redux/apis/getCodeTranslation.api';
import { useDispatch, useSelector } from 'react-redux';
import { VoucherSettingsApi } from '../../../redux/apis/newVoucherSettings.api';
import { createItemMasterWithDetails } from '../../../graphql/postgress_graphql/customMutations';
import NewVoucherSettingsModal from '../Modals/newVoucherSettingModal';
import { setNavigationBlocked } from '../../../redux/reducers/controllNavigation';
import useSaveShortcut from '../../../hooks/useSaveShortcut';
import { Table } from '@aws-amplify/ui-react';
import UseHSNMaster from '../Components/UseHSNMaster';
import AddHSNModal from '../Modals/AddHSNModal';
import { useListVoucherSerialNumbersQuery } from '../../../redux/apis/newVoucherSettings.api';
import { CheckVoucherValid } from '../Components/CheckVoucherValid';

const CustomPaper = styled(Paper)(({ theme }) => ({
  width: 'fit-content',
}));

function AddNewItemRow({
  allAccountArr,
  updateList,
  editedRows,
  setEditedRows,
  setInitialState,
  units,
  showItems,
  purchaseArr,
  salesArr,
  setTaxableValue,
  setRegistrationType,
  registrationType,
  Taxability,
  clasess,
  setAddEvent,
  setBackdropOpen,
  listItemDetails,
  itemID,
  rows,
  setRows,
  todayDate,
  sellingPriceRows,
  setSellingPriceRows,
  editedSellingPriceRows,
  setEditedSellingPriceRows,
  taxableValue,
  setTempSellingPriceRows,
  purchasePriceRows,
  setPurchasePriceRows,
  editedPurchasePriceRows,
  setEditedPurchasePriceRows,
  tempPurchasePriceRows,
  setTempPurchasePriceRows,
  params,
  setParams,
  setSalesArr,
  setPurchaseArr,
  newUnit,
  setNewUnit,
  setActiveRow,
  activeRow,
  categoryId,
  setCategoryId,
  mainCategoryId,
  setMainCategoryId,
  handleResetScroll,
  priceTypeArr,
  newSalesObj,
  newPurchaseObj,
  setPriceTypeArr,
  priceTypeID,
  setPriceTypeID,
  setDeletedSalesRows,

  setDeletedPurchaseRows,
  deletedSalesRows,

  deletedPurchaseRows,
  previousID,
  setPreviousID,
  setEditAble,
  dataCount,
  showActions
}) {
  const { theme } = useThemes();
  const [displayAllAccounts, setDisplayAllAccounts] = useState({
    sales: false,
    purchase: false,
  });
  const ItemTypes = [
    { label: 'GOODS', value: 1 },
    { label: 'SERVICE', value: 2 },
  ];
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);

  const companyType = getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype;

  let userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  let EInvoiceFlag = getCompany?.relatedcompanydetailsnew?.[0]?.einvoiceflag;
  const inputRef = useRef(null);
  const [checked, setChecked] = useState(true);
  const [openMpdalFlag, setOpenModalFlag] = useState(false);
  const [openHsnModal, setOpenHsnModal] = useState(false);
  const [hsnParamsID, setHSNParamsID] = useState('');
  const [openSalesAccountModal, setOpenSalesAccountModal] = useState(false);
  const [openPurchaseAccountModal, setOpenPurchaseAccountModal] = useState(false);
  const [accountType, setAccountType] = useState('');
  const [generalSettingsFlag, setGeneralSettingsFlag] = useState(-1);
  const [activeVouchers, setActiveVouchers] = useState([]);
  const [serialNos, setSerialNos] = useState([]);
  const [validStatus, setValidStatus] = useState(true);
  const [openPriceModal, setOpenPriceModal] = useState(false);
  const [openUnitModal, setUnitModal] = useState(false);
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const [focusCell, setFocusCell] = useState('type');
  const [tableErrArr, setTableErrArr] = useState([]);
  const [focusEf, setFocusEf] = useState('');
  const [updatedSalesPrice, setUpdatedSalesPrice] = useState([]);
  const [updatedPurchasePrice, setUpdatedPurchasePrice] = useState([]);
  const [loading, setLoading] = useState(false);
  const { filterHSN, setFilterHSN, searchHSNDetails, HSNListboxProps, setRow } = UseHSNMaster({
    Type: editedRows?.type === 1 ? 'GOODS' : 'SERVICE',
    Page: '',
  });
 const {
    data: voucherList,
    isLoading: isVoucherListLoading,
    isError: isVoucherListError,
    // refetch
  } = useListVoucherSerialNumbersQuery({
    entrytypecd:  editedRows?.type === 1 ? 'Item' : 'Service',
  });
  const ids = [
    'addCategory',
    'addUnit',
    'SettingsModal',
    'deleteCategory',
    'AddItemsAccountModal',
    'AddHSNModal',
    'CreatePriceType',
    'PriceModal',
  ];
  const anyElementExists = () => ids.some((id) => document.getElementById(id) !== null);

  useSaveShortcut(() => {
    if (!anyElementExists()) {
      saveChanges();
    }
  });

  async function getGeneralSettings(type) {
    try {
      const res = await API.graphql(
        graphqlOperation(listGeneralSetting, {
          entrytypecd: type == 1 ? 'Item' : 'Service',
          financialyearid: getCompany.financialyearid,
        })
      );
      let nextInvNo = '';
      let prefix = '';
      let suffix = '';
      let serialNoArr = [];
      let itemCodeSereis={label:'',value:''};
      let itemCode = '';

      if (res?.data?.listGeneralSetting?.length > 0) {
        let settingsArr = res.data.listGeneralSetting?.map((ele) => {
          if (ele.expiredtimestamp == 0) {
            prefix = ele.prefix;
            suffix = ele.suffix;
            nextInvNo = ele.nextinvoicenumber;
            return ele;
          }
        });
        if (nextInvNo !== -1) {
          let activeVouchers = res.data?.listGeneralSetting?.filter((voucher) => voucher.serialisactive == 1);

          setActiveVouchers(activeVouchers);

          setActiveVouchers(activeVouchers);
          activeVouchers.map((ele) => {
            if (type === 1) {
              if (ele.entrytypecd === 'Item') {
                serialNoArr?.push({
                  label: ele.prefix + ele.nextinvoicenumber + ele.suffix,
                  value: ele.serialnumber,
                });
                // if (ele.serialnumber === serialNoArr?.[0]?.value) {
                //   itemCode = ele.prefix + ele.nextinvoicenumber + ele.suffix;
                // }
                  if(ele?.lastused===1){
              itemCode = ele.prefix + ele.nextinvoicenumber + ele.suffix;
              itemCodeSereis={label:ele.prefix + ele.nextinvoicenumber + ele.suffix,value:ele?.serialnumber};
            }else{
             if (ele.serialnumber === serialNoArr?.[0]?.value) {
               itemCode = ele.prefix + ele.nextinvoicenumber + ele.suffix;
              itemCodeSereis={label:ele.prefix + ele.nextinvoicenumber + ele.suffix,value:ele?.serialnumber};
             }
            }
              }
            } else {
              if (ele.entrytypecd === 'Service') {
                serialNoArr?.push({
                  label: ele.prefix + ele.nextinvoicenumber + ele.suffix,
                  value: ele.serialnumber,
                });
                if (ele.serialnumber === serialNoArr?.[0]?.value) {
                  itemCode = ele.prefix + ele.nextinvoicenumber + ele.suffix;
                }
              }
            }
          });
            setGeneralSettingsFlag(nextInvNo);
          
          setSerialNos(serialNoArr);
          if (!itemID) {
            setGeneralSettingsFlag(nextInvNo);
            setEditedRows((prev) => ({
              ...prev,
              itemCode: itemCode,
              voucherSeries:itemCodeSereis
              // voucherSeries: {
              //   label: serialNoArr?.[0]?.label,
              //   value: serialNoArr?.[0]?.value,
              // },
            }));
            if (setInitialState) {
              setInitialState((prev) => ({
                ...prev,
                itemCode: itemCode,
                 voucherSeries:itemCodeSereis
                // voucherSeries: {
                //   label: serialNoArr?.[0]?.label,
                //   value: serialNoArr?.[0]?.value,
                // },
              }));
            }
          }
        } else {
          if (!itemID) {
            setEditedRows((prev) => ({
              ...prev,
              itemCode: '',
              voucherSeries: {
                label: '',
                value: '',
              },
            }));
            if (setInitialState) {
              setInitialState((prev) => ({
                ...prev,
                itemCode: '',
                voucherSeries: {
                  label: '',
                  value: '',
                },
              }));
            }
            setGeneralSettingsFlag(-1);
          }
        }
      }
    } catch (error) {
      console.log('error', error);
      setBackdropOpen(false);
    }
  }
  const {
    data: unitList,
    isLoading: isUnitListLoading,
    isError: isUnitListError,
  } = useGetCompanyCodeTranslationQuery({ codetype: 'UNITS' });
  const { data: unitUQC, isLoading: idUqcLoading, isError: isUqcError } = useGetCodeTranslationQuery({ codetype: 'UNITS' });
  let unitArrayList = useMemo(() => {
    if (!unitList) return [];
    let unitsArray = [];
    unitList.map((element) => {
      if (element.is_active === '1') {
        unitsArray.push({ option: element.codetext, value: `${element.id}` });
      }
    });
    unitsArray?.map((item) => {
      if (newUnit.value!=="" && (item.option == newUnit.option )) {
        setEditedRows((prev) => ({
          ...prev,
          unite: item.value,
          unit: item.value,
        }));
        setNewUnit({option:"",value:""})
      }
    });
    return unitsArray;
  }, [unitList]);
  let uqcArrayList = useMemo(() => {
    if (!unitUQC) return [];
    return unitUQC
      .filter((item) => item.uqc !== null)
      .map((element) => {
        return { option: element.uqc, value: `${element.id}` };
      });
  }, [unitUQC]);
  let dispatch = useDispatch();
  async function getUnit() {
    try {
      // const res = await API.graphql(
      //   graphqlOperation(getCompanyCodeTranslation, { CodeType: "UNITS" })
      // );
      // let unitsArray = [];
      // res?.data?.getCompanyCodeTranslation.map((element) => {
      //   if (element.Is_Active === "1") {
      //     unitsArray.push({ option: element.CodeText, value: `${element.ID}` });
      //   }
      // });

      // unitsArray?.map((item) => {
      //   if (item.option === newUnit.option) {
      //     setEditedRows((prev) => ({
      //       ...prev,
      //       unit: item.value,
      //     }));
      //   }
      // });
      // setUnits(unitsArray);
      // setUQCArray(
      //   res.data.getCompanyCodeTranslation
      //     .filter((item) => item.UQC !== null)
      //     .map((element) => {
      //       return { option: element.UQC, value: `${element.ID}` };
      //     })
      // );
      dispatch(getCompanyCodeTranslationApi.util.invalidateTags([{ type: 'CodeTranslation', id: 'UNITS' }]));
    } catch (err) {
    } finally {
    }
  }
  function categoryChange(currentNode) {
    setEditedRows((prev) => ({
      ...prev,
      itemCtegorey: currentNode?.value == undefined ? '' : currentNode?.value[1],
      errorStatus: {
        ...prev.errorStatus,
        itemCtegorey: false,
      },
      errorFields: {
        ...prev.errorFields,
        itemCtegorey: '',
      },
    }));
    setCategoryId({ id: currentNode.value[1] });
  }

  useEffect(() => {
    getGeneralSettings(editedRows?.type);
    setFocusCell('type');
  }, [openSettingsModal,voucherList,dataCount]);
  async function saveChanges() {
    try {
      let isValid = true;
      let editedObj = { ...editedRows };

      setLoading(true);
      let validArr = [];
      let errorArr = [];
       if (generalSettingsFlag === -1) {
        if (editedObj?.itemCode === '') {
          isValid = false;
          validArr.push('Item Code');
          errorArr.push('itemCode');
        }
      }
      if (editedObj?.itemName === '') {
        isValid = false;
        validArr.push('Item Name');
        errorArr.push('itemName');
      }
     

      // if (editedRows?.type === 1) {
        if (!editedObj?.unit) {
          isValid = false;
          validArr.push('Unit');
          errorArr.push('unit');
        }
      // }

      if (companyType ===2) {
        if (!editedObj?.hsnCode?.value) {
          isValid = false;
          validArr.push(editedRows?.type === 1 ? 'HSN Code' : 'SAC Code');
          errorArr.push('hsnCode');
        }
      }

      if (editedObj?.showItemInv?.length === 0) {
        isValid = false;
        validArr.push('Show Item in Invoice');
        errorArr.push('showItemInv');
      }
      if (editedObj?.taxability?.value === '' && getCompany?.relatedcompanydetailsnew?.[0].registrationtype != 1) {
        isValid = false;
        validArr.push('Taxability');
        errorArr.push('taxability');
      }
      
      if(generalSettingsFlag===-1){
      const {valid,message}=CheckVoucherValid(editedObj?.itemCode,'Item Code');
          if(!valid){
               isValid = false;
                const element = document?.getElementById('itemCode');
        element?.focus(); 
            showWarningSnackbar(message);

          }
        }
      setValidStatus(isValid);
       
      if (isValid) {
        if (itemID === '') {
          addNewItem(editedObj);
        } else {
          updateItem(editedObj);
        }
        dispatch(setNavigationBlocked(false));
      } else {
        setLoading(false);
        if (validArr.length === 1) {
          showWarningSnackbar(`${validArr}` + ' ' + 'is required');
        }
        if (validArr.length > 1) {
          showWarningSnackbar(`${validArr}` + ' ' + 'are required');
        }
        setTableErrArr(errorArr);
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  function resetItemRow(type) {
    setEditedRows((prev) => ({
      ...prev,
      type: type,
      itemId: '',
      voucherSeries: { label: '', value: '' },
      itemCode: '',
      itemName: '',
      itemCtegorey: type == 1 ? 1 : 2,
      unit: '',
      hsnCode: {
        label: '',
        value: '',
        companyID: '',
        hsnID: '',
        codeType: '',
        description: '',
      },
      showItemInv: [],
      purchaseAccount: { label: '', value: '' },
      salesAccount: { label: '', value: '' },
      taxability: { label: '', value: '' },
      updatePrice: '',
      purchaseAmt: 0,
      sellingprice: 0,
      salesTaxableAmt: 0,
      purchaseTaxableAmt: 0,
      registrationType: '',
      purchaseInvoiceFlag: 0,
      salesInvoiceFlag: 0,
      editable: true,
      new: true,
    }));
  }
  async function addNewItem(obj) {
    try {
      setLoading(true);
      let itemArr = [];
      let sellingPriceArr = [];
      let purchasePriceArr = [];
      const purchaseFlag = obj.purchaseInvoiceFlag;
      const invoiceFlag = obj.salesInvoiceFlag;
      const inputData = {
        currencycd: '13',
        hsnid: String(obj.hsnCode?.value ? obj.hsnCode.value : 0),
        itemcategorycd: obj.itemCtegorey === '' ? 0 : obj.itemCtegorey,
        itemcode: obj?.itemCode,
        itemname: obj?.itemName,
        itemtype: obj.type === 1 ? 'GOODS' : 'SERVICE',
        measurementcd: Number(obj.unit),
        purchaseaccountid: purchaseFlag === 0 ? 0 : obj.purchaseAccount?.value,
        purchaseinvoiceflag: purchaseFlag,
        reversechargeflag: 0,
        salesaccountid: invoiceFlag === 0 ? 0 : obj.salesAccount?.value,
        salesinvoiceflag: invoiceFlag,
        taxabilitycd: obj?.taxability.value,
        is_active: 1,
        serialnumber: obj?.voucherSeries.value,
        description: '',
      };
      itemArr.push(inputData);
      let salesObj = {};
      if (
        sellingPriceRows.length > 0
        //  && editedRows.salesInvoiceFlag === 1
      ) {
        sellingPriceRows.map((ele) => {
          // if (ele.amount !== 0 && ele.amount !== "") {
          salesObj = {
            amount: ele.amount === '' ? 0 : Number(ele.amount),
            effectivedate: ele.effectivefrom === '' ? 0 : new Date(ele?.effectivefrom).getTime() / 1000,
            expireddate: ele.effectiveto === '' ? 0 : new Date(ele?.effectiveto).getTime() / 1000,
            gstcompensationtype: ele.cesstype,
            gstcompensationvalue: ele.cess === '' ? 0 : ele.cess,
            gstrate: ele?.gstRate?.id === '' ? 0 : Number(ele?.gstRate?.id),
            hsnid: String(0),
            invoicetype: ele.invoiceType,
            discounttype: ele.DiscountType,
            discountvalue: ele.DiscountValue,
            isactive: ele.activeType,
            pricetype: ele.priceType?.label,
            pricetypeid: ele.priceType?.value,
            isdefault: ele.isActive,
          };

          sellingPriceArr.push(salesObj);
          // }
        });
      }
      let purchaseObj = {};

      if (
        purchasePriceRows.length > 0
        // && editedRows.purchaseInvoiceFlag === 1
      ) {
        purchasePriceRows.map((ele) => {
          // if (ele.amount !== 0 && ele.amount !== "") {
          purchaseObj = {
            amount: ele.amount === '' ? 0 : Number(ele.amount),
            effectivedate: ele.effectivefrom === '' ? 0 : new Date(ele?.effectivefrom).getTime() / 1000,
            expireddate: ele.effectiveto === '' ? 0 : new Date(ele?.effectiveto).getTime() / 1000,
            gstcompensationtype: ele.cesstype,
            gstcompensationvalue: ele.cess === '' ? 0 : ele.cess,
            gstrate: ele?.gstRate?.id === '' ? 0 : Number(ele?.gstRate?.id),
            hsnid: String(0),
            discounttype: ele.DiscountType,
            discountvalue: ele.DiscountValue,
            invoicetype: ele.invoiceType,
            isactive: ele.activeType,
            pricetype: ele.priceType?.label??'',
            pricetypeid: ele.priceType?.value??0,
            isdefault: ele.isActive,
          };

          purchasePriceArr.push(purchaseObj);
          // }
        });
      }

      const resItem = await API.graphql(
        graphqlOperation(createItemTransaction, {
          createItemTransactionInput: {
            itemmaster: itemArr,
            itemamountdetails: [...purchasePriceArr, ...sellingPriceArr],
            itemimages: [],
          },
        })
      );
      if (resItem.data.createItemTransaction.statuscode === 'Error') {
        setBackdropOpen(false);
        showWarningSnackbar(resItem.data.createItemTransaction.statusmessage);
      } else {
        dispatch(
          VoucherSettingsApi.util.invalidateTags([
            'listUsedVoucherSettings',
            {
              type: 'listVoucherSettings',
              id: obj.type === 1 ? 'Item' : 'Service',
            },
          ])
        );
        updateList(resItem.data.createItemTransaction?.itemcode, true);
        setTempSellingPriceRows(newSalesObj);
        setEditedSellingPriceRows(newSalesObj);
        setEditedPurchasePriceRows(newPurchaseObj);
        setTempPurchasePriceRows(newPurchaseObj);
        setPurchasePriceRows([newPurchaseObj]);
        setSellingPriceRows([newSalesObj]);
        setPreviousID('');
        showSuccessSnackbar('Item created Successfully');
        dispatch(setNavigationBlocked(false));
        const element = document.getElementById('salesAccount');
        element?.focus();

        setCategoryId(mainCategoryId);
        // getGeneralSettings(type);
        let type = resItem.data.createItemTransaction.itemtype === 'GOODS' ? 1 : 2;

        getGeneralSettings(type);
        resetItemRow(type);
        setFocusCell('type');
        // listItemDetails();
        inputRef.current.focus();
      }
    } catch (error) {
      setLoading(false);
      console.log('error', error);
      const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
      showWarningSnackbar(errorMessage);
      console.log('error', error);
    }
  }

  async function updateItem(obj) {
    try {
      setLoading(true);
      const purchaseFlag = obj.purchaseInvoiceFlag;
      const invoiceFlag = obj.salesInvoiceFlag;
      let comments = obj?.description;
      const inputData = {
        hsnid: String(obj.hsnCode?.value ? obj.hsnCode.value : 0),
        currencycd: '',
        itemid: itemID,
        itemcategorycd: obj.itemCtegorey === '' ? 0 : obj.itemCtegorey,
        itemcode: obj?.itemCode,
        itemname: obj?.itemName,
        itemtype: obj.type === 1 ? 'GOODS' : 'SERVICE',
        measurementcd: Number(obj.unit),
        purchaseaccountid: purchaseFlag === 0 ? 0 : obj.purchaseAccount?.value,
        purchaseinvoiceflag: purchaseFlag,
        reversechargeflag: 0,
        salesaccountid: invoiceFlag === 0 ? 0 : obj.salesAccount?.value,
        salesinvoiceflag: invoiceFlag,
        taxabilitycd: Number(obj?.taxability.value),
        is_active: 1,
        serialnumber: obj?.voucherSeries.value,
        description: comments === '' ? '' : comments?.join('**'),
        expiredtimestamp: 0,
        companyid: getCompany?.companyid,
        financialyearid: userPreferece?.financialYear?.financialyearid,
        lastupdatedby: '',
      };

      let salesObj = {};
      let purchaseObj = {};
      let arr = [];
      let purchaseRows = [...deletedPurchaseRows, ...purchasePriceRows];
      let salesRows = [...deletedSalesRows, ...sellingPriceRows];
      Math.floor(new Date().getTime() / 1000);

      let currentTimesStamp = Math.floor(new Date().getTime() / 1000);
      if (obj?.salesInvoiceFlag === 0) {
        if (updatedSalesPrice?.length > 0) {
          let deletedArr = [...updatedSalesPrice].map((item, ind) => {
            return { ...item, expiredtimestamp: currentTimesStamp };
          });

          salesRows = [...deletedSalesRows, ...deletedArr, ...sellingPriceRows];
        }
      }

      if (obj?.purchaseInvoiceFlag === 0) {
        if (updatedPurchasePrice?.length > 0) {
          let deletedArr = [...updatedPurchasePrice].map((item, ind) => {
            return { ...item, expiredtimestamp: currentTimesStamp };
          });

          purchaseRows = [...deletedPurchaseRows, ...deletedArr, ...purchasePriceRows];
        }
      }

      if (salesRows.length > 0) {
        salesRows.map((ele) => {
          salesObj = {
            id: ele?.id ? ele?.id : 0,
            amount: ele.amount === '' ? 0 : Number(ele.amount),
            effectivedate: ele.effectivefrom === '' ? 0 : new Date(ele?.effectivefrom).getTime() / 1000,
            expireddate: ele.effectiveto === '' ? 0 : new Date(ele?.effectiveto).getTime() / 1000,
            gstcompensationtype: String(ele.cesstype),
            gstcompensationvalue: ele.cess === '' ? 0 : ele.cess,
            gstrate: ele?.gstRate?.id === '' ? 0 : Number(ele?.gstRate?.id),
            hsnid: String(0),
            itemid: itemID,
            discounttype: ele.DiscountType,
            discountvalue: ele.DiscountValue,
            invoicetype: ele.invoiceType,
            isactive: ele.activeType,
            pricetype: ele?.priceType?.label,
            pricetypeid: ele?.priceType?.value,
            isdefault: ele.isActive,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: 0,
          };
          arr.push(salesObj);
        });
      } else {
        arr.push([
          {
            id: 0,
            expiredtimestamp: 0,
            amount: 0,
            effectivedate: 0,

            expireddate: 0,
            itemid: itemID,
            gstcompensationtype: '1',
            gstcompensationvalue: 0,
            gstrate: 0,
            hsnid: String(0),
            invoicetype: 1,
            discounttype: 1,
            discountvalue: 0,
            isactive: 1,
            pricetype: '',
            pricetypeid: 0,
            isdefault: 1,

            companybranchid: 0,
          },
        ]);
      }

      if (purchaseRows.length > 0) {
        purchaseRows.map((ele) => {
          purchaseObj = {
            id: ele?.id ? ele?.id : 0,
            amount: ele.amount === '' ? 0 : Number(ele.amount),
            effectivedate: ele.effectivefrom === '' ? 0 : new Date(ele?.effectivefrom).getTime() / 1000,
            expireddate: ele.effectiveto === '' ? 0 : new Date(ele?.effectiveto).getTime() / 1000,
            gstcompensationtype: String(ele.cesstype),
            gstcompensationvalue: ele.cess === '' ? 0 : ele.cess,
            gstrate: ele?.gstRate?.id === '' ? 0 : Number(ele?.gstRate?.id),
            hsnid: String(0),
            itemid: itemID,
            discounttype: ele.DiscountType,
            discountvalue: ele.DiscountValue,
            invoicetype: ele.invoiceType,
            isactive: ele.activeType,
             pricetype: ele?.priceType?.label??'',
            pricetypeid: ele?.priceType?.value??0,
            isdefault: ele.isActive,
            expiredtimestamp: ele.expiredtimestamp ? ele?.expiredtimestamp : 0,
            companybranchid: 0,
          };
          arr.push(purchaseObj);
        });
      } else {
        arr.push([
          {
            id: 0,
            expiredtimestamp: 0,
            amount: 0,
            effectivedate: 0,
            itemid: itemID,
            expireddate: 0,

            gstcompensationtype: '1',
            gstcompensationvalue: 0,
            gstrate: 0,
            hsnid: String(0),
            invoicetype: 2,
            discounttype: 1,
            discountvalue: 0,
            isactive: 1,
            pricetype: '',
            pricetypeid: 0,
            isdefault: 1,

            companybranchid: 0,
          },
        ]);
      }

      const variables = {
        createItemMasterInput: inputData,
        createItemAmountDetailsInput: arr,
      };

      const response = await API.graphql(graphqlOperation(createItemMasterWithDetails, variables));

      updateList(response.data.createItemMaster?.itemcode);
      setEditedRows((prev) => ({
        ...prev,
        type: response.data.createItemMaster.itemtype === 'GOODS' ? 1 : 2,
      }));
      setPreviousID('');
      setEditAble(false);
      showSuccessSnackbar('Item Updated Successfully');
      const element = document.getElementById('salesAccount');
      element?.focus();

      setAddEvent(false);
      resetItemRow(1);
      listItemDetails();
      setFocusCell('type');
      inputRef?.current?.focus();
    } catch (error) {
      setLoading(false);
      console.log('error', error);
      const rawMessage = error.errors[0].message.split('RDSHttp:')[1];
      const parsedMessage = JSON.parse(rawMessage).message;
      const errorMessage = parsedMessage.split('ERROR: ')[1].split(';')[0];
      showWarningSnackbar(errorMessage);
    }
  }

  function handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }

    if (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) {
      if (required && e.target.value === '') {
        e.preventDefault();
        e.stopPropagation();
        showWarningSnackbar(warMsg);
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }

  function handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID, multiple) {
    const activeDescendantId = e.target.getAttribute('aria-activedescendant');
    const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }
    if ((e.key === 'Enter' || e.key === 'Tab') && !e.shiftKey) {
      if (multiple && e.key === 'Enter') {
        return; // Exit without moving focus to next field
      }

      if (required === true && e?.target?.value === '' && isAutocompleteOpen && !activeDescendantId) {
        e.preventDefault();
        e.stopPropagation();

        showWarningSnackbar(warMsg);
        const currentElement = document.getElementById(currentId);
        currentElement?.focus();
      } else {
        e.preventDefault();
        e.stopPropagation();
        const nextElement = document.getElementById(nextId);
        nextElement?.focus();
      }
    }
  }
  function handleMultiAutoKeyDown(e, currentId, nextId, required, warMsg, prevID) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      const prevElement = document.getElementById(prevID);
      prevElement?.focus();
      return;
    }
    const activeDescendantId = e.target.getAttribute('aria-activedescendant');
    const isAutocompleteOpen = document.activeElement.getAttribute('aria-expanded') === 'true';
    if (
      (e.key === 'Enter' || (e.key === 'Tab' && !e.shiftKey)) &&
      required === true &&
      editedRows?.showItemInv?.length === 0 &&
      isAutocompleteOpen &&
      !activeDescendantId
    ) {
      e.preventDefault();
      e.stopPropagation();
      const element = document.getElementById(currentId);
      showWarningSnackbar(warMsg);
      element?.focus();
      return;
    } else if (e.key === 'Enter' || e.key === 'Tab') {
      if (e.key === 'Enter') {
        e.stopPropagation();
        e.stopPropagation();
        return;
      }
      if (!isAutocompleteOpen) {
        const element = document.getElementById(nextId);
        element?.focus();
      }
    }
  }

  useEffect(() => {
    let elements = document.getElementsByName(tableErrArr[0]);
    setTimeout(() => {
      if (elements.length > 0) {
        const element = elements[0];
        if (element.tabIndex === -1) {
          element.setAttribute('tabindex', '0');
        }

        element.focus();
      }
    }, 0);
  }, [tableErrArr]);
  const handleSelectionChange = (newValue) => {
    let puchaseFlag = 0;
    let salesFlag = 0;

    let uniqueValues = newValue?.filter((item, index, self) => index === self.findIndex((t) => t.value === item.value));

    if (uniqueValues.length === 0) {
      setPurchasePriceRows([newPurchaseObj]);
      setSellingPriceRows([newSalesObj]);
    }

    if (checked) {
      puchaseFlag = uniqueValues.some((ele) => ele.value === 1) ? 1 : 0;
      salesFlag = uniqueValues.some((ele) => ele.value === 2) ? 1 : 0;

      if (puchaseFlag === 0) setPurchasePriceRows([newPurchaseObj]);
      if (salesFlag === 0) setSellingPriceRows([newSalesObj]);
      let salesRows = sellingPriceRows.filter((row) => row.id !== 0);
      setUpdatedSalesPrice(salesRows);
      let purchaseRows = purchasePriceRows.filter((row) => row.id !== 0);

      setUpdatedPurchasePrice(purchaseRows);

      if (params?.id !== '') {
        if (updatedSalesPrice.length > 0) setSellingPriceRows(updatedSalesPrice);
      }
      if (puchaseFlag === 1 && params?.id !== '') {
        if (updatedPurchasePrice.length > 0) setPurchasePriceRows(updatedPurchasePrice);
      }

      setEditedRows((prev) => ({
        ...prev,
        showItemInv: uniqueValues,
        purchaseInvoiceFlag: puchaseFlag,
        salesInvoiceFlag: salesFlag,
        purchaseAccount: puchaseFlag ? { label: 'Purchase A/c', value: 13 } : { label: '', value: '' },
        salesAccount: salesFlag ? { label: 'Sales A/c', value: 17 } : { label: '', value: '' },
        errorStatus: {
          ...prev.errorStatus,
          showItem: uniqueValues.length === 0,
        },
        errorFields: {
          ...prev.errorFields,
          showItem: uniqueValues.length === 0 ? 'Please select the Item in Purchase or Sales Invoice' : '',
        },
      }));
    }
  };

  return (
    <>
      <TableRow
        className={clasess.table}
        sx={{
          '& .MuiTableCell-root': {
            p: 0,
          },
        }}
      >
        <TableCell></TableCell>
        <TableCell>
          <TextField
            openOnFocus={focusCell === 'type' ? true : false}
            autoFocus={focusCell === 'type' ? true : false}
            // ref={inputRef}
            id="type"
            name="type"
            size="small"
            select
            value={editedRows?.type}
            disabled={editedRows?.itemId === '' ? false : true}
            onChange={(e) => {
              let value = e.target.value;
              getGeneralSettings(value);
              setEditedRows((prev) => ({
                ...prev,
                type: value,
                itemCtegorey: value == 2 ? 2 : 1,
              }));
            }}
            onKeyDown={(e) => {
              const warMsg = '';
              const currentId = 'type';
              const nextId = 'seriesVouchers';
              const prevID = '';
              const required = true;

              handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                border: 'none !important',
                outline: 'none !important',
                boxShadow: 'none !important',
                '&:hover': {
                  border: 'none !important',
                  outline: 'none !important',
                },
                '&.Mui-focused': {
                  border: 'none !important',
                  outline: 'none !important',
                  boxShadow: 'none !important',
                },
                '& fieldset': {
                  border: 'none !important',
                },
              },

              // Extra safety to remove outline from input itself
              '& .MuiOutlinedInput-input': {
                outline: 'none !important',
              },

              // Remove global focus-visible ring
              '&:focus-visible': {
                outline: 'none !important',
                boxShadow: 'none !important',
              },
              outline: 'none !important',
              width: '100%',
            }}
          >
            {ItemTypes.map((type) => (
              <MenuItem key={type.value} value={type.value}>
                {type.label}
              </MenuItem>
            ))}
          </TextField>
        </TableCell>

        <TableCell  sx={{
            outline: 'none !important',
            border:(generalSettingsFlag === -1 && (editedRows?.itemCode === ''  && validStatus === false)) ? '3px solid #e55353 !important' : '',
          }}>
          {generalSettingsFlag !== -1 ? (
            <>
              <Autocomplete
                openOnFocus
                fullWidth
                disableClearable
                isOptionEqualToValue={(option, value) => option.value === value?.value}
                id="seriesVouchers"
                name="seriesVouchers"
                options={generalSettingsFlag !== -1 ? serialNos : []}
                // value={generalSettingsFlag !== -1 ? editedRows?.itemCode : ""}
                value={editedRows?.itemCode}
                disabled={editedRows?.itemId === '' ? false : true}
                size="small"
                onChange={(e, newValue) => {
                  let voucherNo = '';
                  if (newValue?.value !== '') {
                    activeVouchers?.map((ele) => {
                      if (ele.serialnumber === newValue.value) {
                        voucherNo = ele.prefix + ele.nextinvoicenumber + ele.suffix;
                      }
                    });

                    setEditedRows((prev) => ({
                      ...prev,
                      voucherSeries: newValue,
                      itemCode: voucherNo,
                    }));
                  }
                }}
                onKeyDown={(e) => {
                  const currentId = 'seriesVouchers';
                  const nextId = editedRows?.itemCode ? 'itemName' : 'seriesVouchers';
                  const prevID = 'type';
                  const required = true;
                  const warMsg = 'Item Code is required';
                  handleAutoCompleteKeyDown(
                    e,

                    currentId,
                    nextId,
                    required,
                    warMsg,
                    prevID
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    sx={{
                      '.MuiFormLabel-asterisk': {
                        color: 'danger.main',
                        fontSize: '16px',
                        fontWeight: 'bold',
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      ...params.InputProps,
                      readOnly: generalSettingsFlag !== -1 && editedRows?.itemId === '' ? false : true,
                      endAdornment: (
                        <>
                          {editedRows?.itemId === '' && (
                            <InputAdornment position="end">
                              <Tooltip title={'Item Code Settings'} placement="right" disableInteractive arrow>
                                <IconButton
                                  onClick={() => {
                                    setOpenSettingsModal(true);
                                  }}
                                  onFocus={() => {
                                    setFocusEf('settings');
                                  }}
                                  onBlur={() => {
                                    setFocusEf('');
                                  }}
                                >
                                  <Settings
                                    sx={{
                                      color: '#b5b5b5',
                                      fontSize: '18px',
                                      transition: 'transform 0.3s',
                                      transform: `rotate(${focusEf === 'settings' ? '75deg' : '0'})`,
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </InputAdornment>
                          )}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: 'none !important',
                    outline: 'none !important',
                    boxShadow: 'none !important',
                    '&:hover': {
                      border: 'none !important',
                      outline: 'none !important',
                    },
                    '&.Mui-focused': {
                      border: 'none !important',
                      outline: 'none !important',
                      boxShadow: 'none !important',
                    },
                    '& fieldset': {
                      border: 'none !important',
                    },
                  },

                  // Extra safety to remove outline from input itself
                  '& .MuiOutlinedInput-input': {
                    outline: 'none !important',
                  },

                  // Remove global focus-visible ring
                  '&:focus-visible': {
                    outline: 'none !important',
                    boxShadow: 'none !important',
                  },
                  outline: 'none !important',
                  width: '100%',
                }}
                InputProps={{
                  ...params.InputProps,
                  readOnly: generalSettingsFlag !== -1 && editedRows?.itemId === '' ? false : true,
                  endAdornment: editedRows?.itemId === '' && (
                    <>
                      <InputAdornment position="end">
                        <Tooltip title={'Item Code Settings'} placement="right" disableInteractive arrow>
                          <IconButton
                            onClick={() => {
                              setOpenSettingsModal(true);
                            }}
                          >
                            <Settings
                              sx={{
                                color: '#b5b5b5',
                                fontSize: '18px',
                                transition: 'transform 0.3s',
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    </>
                  ),
                }}
              />
            </>
          ) : (
            <>
              <TextField
                id="seriesVouchers"
                name="seriesVouchers"
                size="small"
                fullWidth
                type="text"
                value={editedRows?.itemCode}
                 disabled={editedRows?.itemId === '' ? false : true}
                onChange={(e) => {

                  const value = e.target.value;

                  if (value === '') {
                    setEditedRows((prev) => ({
                      ...prev,
                      itemCode: '',
                    }));
                  } else {
                    setEditedRows((prev) => ({
                      ...prev,
                      itemCode: value,
                    }));
                  }
                }}
                onKeyDown={(e) => {
                  const warMsg = 'Item Code is required';

                  const currentId = 'seriesVouchers';
                  const nextId = 'itemName';
                  const prevID = 'type';
                  const required = true;
                  handleTextKeyDown(
                    e,

                    currentId,
                    nextId,
                    required,
                    warMsg,
                    prevID
                  );
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: 'none !important',
                    outline: 'none !important',
                    boxShadow: 'none !important',
                    '&:hover': {
                      border: 'none !important',
                      outline: 'none !important',
                    },
                    '&.Mui-focused': {
                      border: 'none !important',
                      outline: 'none !important',
                      boxShadow: 'none !important',
                    },
                    '& fieldset': {
                      border: 'none !important',
                    },
                  },

                  // Extra safety to remove outline from input itself
                  '& .MuiOutlinedInput-input': {
                    outline: 'none !important',
                  },

                  // Remove global focus-visible ring
                  '&:focus-visible': {
                    outline: 'none !important',
                    boxShadow: 'none !important',
                  },
                  outline: 'none !important',
                  width: '100%',
                }}
                InputProps={{
                  endAdornment: editedRows?.itemId === '' && (
                    <>
                      <InputAdornment position="end">
                        <Tooltip title={'Item Code Settings'} placement="right" disableInteractive arrow>
                          <IconButton
                            onClick={() => {
                              setOpenSettingsModal(true);
                            }}
                          >
                            <Settings
                              sx={{
                                color: '#b5b5b5',
                                fontSize: '18px',
                                transition: 'transform 0.3s',
                              }}
                            />
                          </IconButton>
                        </Tooltip>
                      </InputAdornment>
                    </>
                  ),
                }}
              />
            </>
          )}
        </TableCell>

        <TableCell
          sx={{
            outline: 'none !important',
            border: editedRows?.itemName === '' && validStatus === false ? '3px solid #e55353 !important' : '',
          }}
        >
          <TextField
            id="itemName"
            name="itemName"
            type="text"
            size="small"
            value={editedRows.itemName}
            onKeyDown={(e) => {
              const warMsg = 'Item Name is required';

              const currentId = 'itemName';
              const nextId = 'treeDrp';
              const prevID = 'seriesVouchers';
              const required = true;
              handleTextKeyDown(
                e,

                currentId,
                nextId,
                required,
                warMsg,
                prevID
              );
            }}
            onChange={(e) => {
  const itemNameRegex =  /^.*$/;
  const value = e.target.value;
  const trimmedValue = value.trimStart(); 

  if (value !== '') {
    if (itemNameRegex.test(value)) {

      const capitalizedValue = trimmedValue
        .split(/\s+/) 
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      setEditedRows((prev) => ({
        ...prev,
        itemName: capitalizedValue,
      }));
    }
  } else {
    setEditedRows((prev) => ({
      ...prev,
      itemName: '',
    }));
  }
}}

            sx={{
              '& .MuiOutlinedInput-root': {
                border: 'none !important',
                outline: 'none !important',
                boxShadow: 'none !important',
                '&:hover': {
                  border: 'none !important',
                  outline: 'none !important',
                },
                '&.Mui-focused': {
                  border: 'none !important',
                  outline: 'none !important',
                  boxShadow: 'none !important',
                },
                '& fieldset': {
                  border: 'none !important',
                },
              },

              // Extra safety to remove outline from input itself
              '& .MuiOutlinedInput-input': {
                outline: 'none !important',
              },

              // Remove global focus-visible ring
              '&:focus-visible': {
                outline: 'none !important',
                boxShadow: 'none !important',
              },
              outline: 'none !important',
              width: '100%',
            }}
          />
        </TableCell>
        <TableCell sx={{ p: '0', outline: 'none !important' }} tabIndex="0">
          <TreeDropdown
            key={categoryId}
            disabled={editedRows.itemName === '' ? true : false}
            id="itemCtegorey"
            name="itemCtegorey"
            setState={setEditedRows}
            setInitialState={setInitialState}
            setMainCategoryId={setMainCategoryId}
            parentDetails={categoryId}
            MainParent={editedRows?.type === 1 ? 'GOODS' : 'SERVICE'}
            onChange={categoryChange}
          />
        </TableCell>
        <TableCell
          className={focusCell === 'unit' ? clasess.focusTableCell : ''}
          sx={{
            border:
            //  editedRows?.type === 1 &&
             !editedRows?.unit && validStatus === false ? '3px solid #e55353 !important' : '',
          }}
        >
          <Autocomplete
            disabled={editedRows.itemName === '' ? true : false}
            disableClearable
            placeholder="Unit of Measurement"
            id="unit"
            name="unit"
            size="small"
            openOnFocus
            autoFocus
            options={[...unitArrayList, 'Add Units']}
            onKeyDown={(e) => {
              const warMsg = 'Unit is required';

              const currentId = 'unit';
              const nextId = editedRows?.unit ? (companyType === 1 ? 'showItemInv' : 'hsnCode') : 'unit';
              const prevID = 'treeDrp';
              const required = 
              // editedRows?.type == 2 ? false : 
              true;
              handleAutoCompleteKeyDown(
                e,

                currentId,
                nextId,
                required,
                warMsg,
                prevID
              );
            }}
            getOptionLabel={(option) => option.option}
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                border: 'none !important',
                '& fieldset': {
                  border: 'none !important',
                },
                '&:hover fieldset': {
                  border: 'none !important',
                },
                '&.Mui-focused fieldset': {
                  border: 'none !important',
                },
                boxShadow: 'none !important',
              },
              '& .MuiOutlinedInput-input': {
                outline: 'none !important',
                boxShadow: 'none !important',
              },
              '& .MuiInputBase-root': {
                border: 'none !important',
                outline: 'none !important',
                boxShadow: 'none !important',
              },
              '& .MuiAutocomplete-inputRoot': {
                border: 'none !important',
                outline: 'none !important',
              },
              '&:focus-visible': {
                outline: 'none !important',
                boxShadow: 'none !important',
              },
            }}
            renderOption={(props, option) => (
              <>
                {option === 'Add Units' ? (
                  <MenuItem
                    value={'addUnits'}
                    onClick={(e) => {
                      e.stopPropagation();
                      setUnitModal(true);
                    }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'sticky',
                      bottom: '-8px',
                      backgroundColor: grey[50],
                      '&:hover': {
                        backgroundColor: grey[200],
                      },
                      color: theme?.palette?.TmId.id.toString().includes('9') ? 'black' : '',
                    }}
                  >
                    <Settings fontSize="small" sx={{ marginRight: '5px' }} />
                    <ListItemText primary={'Add Units'} />
                  </MenuItem>
                ) : (
                  <li {...props} key={option.value} value={option.value}>
                    {/* <ListItemText primary={option.option} /> */}
                    {option.option}
                  </li>
                )}
              </>
            )}
            PaperComponent={(props) => <CustomPaper {...props} />}
            value={unitArrayList.find((unit) => unit.value === editedRows.unit) || null}
            onChange={(event, newValue) => {
              if (!newValue || newValue.value !== 'addUnits') {
                setEditedRows((prev) => ({
                  ...prev,
                  unit: newValue ? newValue.value : '',
                }));
              }
            }}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => (
              <TextField
                {...params}
                required={true}
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    border: 'none !important',
                    '& fieldset': {
                      border: 'none !important',
                    },
                  },
                  '& .MuiInputBase-root': {
                    border: 'none !important',
                  },
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
              />
            )}
          />
        </TableCell>
        {companyType !== 1 && (
          <TableCell
            className={focusCell === 'hsnCode' ? clasess.focusTableCell : ''}
            sx={{
              border: (companyType !== 1 && companyType!==3) && !editedRows?.hsnCode?.value && validStatus === false ? '3px solid #e55353 !important' : '',
            }}
          >
            <Autocomplete
              id="hsnCode"
              name="hsnCode"
              disableClearable
              disablePortal={true}
              placeholder="HSN Code"
              disabled={editedRows?.itemName === '' || params?.view === true ? true : false}
              getOptionDisabled={(option) => option === (editedRows?.Type === 1 ? 'Add HSN Code' : 'Add SAC Code')}
              options={editedRows?.type === 1 ? ['Add HSN Code', ...filterHSN] : ['Add SAC Code', ...filterHSN]}
              isOptionEqualToValue={(option, value) => option?.value == value?.value}
              openOnFocus
              value={editedRows?.hsnCode}
              onChange={(event, newValue) => {
                if (newValue?.value !== 'addHsn') {
                  setEditedRows((prev) => ({
                    ...prev,
                    hsnCode: newValue,
                  }));
                }
              }}
              onInputChange={(e, newValue) => {
                setRow(0);
                if (newValue) {
                  searchHSNDetails(newValue, 0, 20);
                } else {
                  searchHSNDetails('', 0, 20);
                }
              }}
              ListboxProps={HSNListboxProps}
              onKeyDown={(e) => {
                const warMsg = editedRows?.type === 1 ? 'HSN Code is required' : 'SAC Code is required';
                const name = 'hsnCode';
                const currentId = 'hsnCode';
                const nextId = (e.target.value || companyType===3)? 'showItemInv' : 'hsnCode';
                const prevID = 'unit';
                const required = companyType===2 ? true : false;
                handleAutoCompleteKeyDown(
                  e,

                  currentId,
                  nextId,
                  required,
                  warMsg,
                  prevID
                );
              }}
              sx={{
                width: '100%',
                '& .MuiOutlinedInput-root': {
                  border: 'none !important',
                  '& fieldset': {
                    border: 'none !important',
                  },
                  '&:hover fieldset': {
                    border: 'none !important',
                  },
                  '&.Mui-focused fieldset': {
                    border: 'none !important',
                  },
                  boxShadow: 'none !important',
                },
                '& .MuiOutlinedInput-input': {
                  outline: 'none !important',
                  boxShadow: 'none !important',
                },
                '& .MuiInputBase-root': {
                  border: 'none !important',
                  outline: 'none !important',
                  boxShadow: 'none !important',
                },
                '& .MuiAutocomplete-inputRoot': {
                  border: 'none !important',
                  outline: 'none !important',
                },
                '&:focus-visible': {
                  outline: 'none !important',
                  boxShadow: 'none !important',
                },
              }}
              size="small"
              renderInput={(params) => (
                <TextField
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '16px',
                      fontWeight: 'bold',
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...params}
                />
              )}
              renderOption={(props, option) => (
                <>
                  {option === (editedRows?.type === 1 ? 'Add HSN Code' : 'Add SAC Code') ? (
                    <MenuItem
                      value={'addHsn'}
                      onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        setOpenHsnModal(true);
                        setHSNParamsID('');
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        position: 'sticky',
                        top: '-8px',
                        mt: '-8px',
                        backgroundColor: grey[50],
                        '&:hover': {
                          backgroundColor: grey[200],
                        },
                      }}
                    >
                      <AddBox
                        fontSize="small"
                        sx={{
                          marginRight: '5px',
                          color: 'primary.main',
                        }}
                      />
                      <ListItemText sx={{ color: 'primary.main' }} primary={editedRows?.type === 1 ? 'Add HSN Code' : 'Add SAC Code'} />
                    </MenuItem>
                  ) : (
                    <li {...props}>{option.label}</li>
                  )}
                </>
              )}
               componentsProps={{
                                popper: {
                                  style: {
                                    maxWidth: 300,
                                    overflow: "auto",
                                  },
                                },
                              }}
            />
          </TableCell>
        )}
        <TableCell
          sx={{
            width: '100%',
            outline: 'none !important',
            border: editedRows?.showItemInv?.length === 0 && validStatus === false ? '3px solid #e55353 !important' : '',
          }}
        >
          <Autocomplete
            size="small"
            multiple
            openOnFocus
            autoFocus
            disableClearable
            options={showItems}
            name="showItemInv"
            id="showItemInv"
            fullWidth
            getOptionLabel={(option) => option?.label}
            disableCloseOnSelect
            disabled={
              editedRows?.itemName === '' || params?.view === true
                ? //  && (!page && page !== "Purchase" )
                  true
                : false
            }
            value={editedRows?.showItemInv}
            onChange={(e, newValue) => {
              handleSelectionChange(newValue);
            }}
            onKeyDown={(e) => {
              const warMsg = 'Please Select item in Sales or Purchase invoice';

              const currentId = 'showItemInv';
              const nextId = 'purchaseAccount';
              const prevID = companyType===1?'unit':'hsnCode';
              const required = true;
              handleMultiAutoKeyDown(
                e,

                currentId,
                nextId,
                required,
                warMsg,
                prevID
              );
            }}
            renderInput={(params) => (
              <TextField
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                {...params}
                variant="outlined"
                required={true}
                sx={{
                  '& .MuiInputBase-input': {
                    caretColor: 'transparent',
                  },
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                  '.MuiOutlinedInput-root': {
                    height: '35px',
                    pr: '0 !important',
                  },
                }}
              />
            )}
            sx={{
              '& .MuiOutlinedInput-root': {
                border: 'none !important',
                outline: 'none !important',
                boxShadow: 'none !important',
                '&:hover': {
                  border: 'none !important',
                  outline: 'none !important',
                  boxShadow: 'none !important',
                },
                '&.Mui-focused': {
                  border: 'none !important',
                  outline: 'none !important',
                  boxShadow: 'none !important',
                },
                '& fieldset': {
                  border: 'none !important',
                },
              },
              '& .MuiOutlinedInput-input': {
                outline: 'none !important',
                boxShadow: 'none !important',
              },
              '& .MuiAutocomplete-endAdornment': {
                display: 'none !important', // optional: hides dropdown arrow if you want a cleaner look
              },
              outline: 'none !important',
              boxShadow: 'none !important',
              border: 'none !important',
              width: '180px',
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props} key={option.value} value={option.value} style={{}}>
                {
                  <>
                    <Checkbox
                      value={option.value}
                      sx={{
                        fontSize: '16px',
                        paddingTop: '0px', // Optional: adjust padding if needed
                        paddingBottom: '0px',
                      }}
                      // onChange={(e) => {
                      //   const isChecked = e.target.checked;

                      //   setEditedRows((prev) => {
                      //     let updatedShowItem;

                      //     if (isChecked) {
                      //       // Checkbox is checked, add the item to data.showItem if it doesn't exist
                      //       if (
                      //         !prev.showItemInv?.find(
                      //           (item) => item.value === option.value
                      //         )
                      //       ) {
                      //         updatedShowItem = [
                      //           ...(prev.showItem || []),
                      //           { label: "Purchase", value: option.value },
                      //         ];
                      //       } else {
                      //         updatedShowItem = prev.showItemInv;
                      //       }
                      //     } else {
                      //       // Checkbox is unchecked, remove the item from data.showItem if it exists
                      //       updatedShowItem = prev.showItemInv?.filter(
                      //         (item) => item.value !== option.value
                      //       );
                      //     }

                      //     return {
                      //       ...prev,
                      //       showItemInv: updatedShowItem,
                      //     };
                      //   });
                      // }}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setEditedRows((prev) => {
                          let updatedShowItem = isChecked
                            ? [...(prev.showItemInv || []), option]
                            : prev.showItemInv?.filter((item) => item.value !== option.value);
                          handleSelectionChange(updatedShowItem);
                          return { ...prev, showItemInv: updatedShowItem };
                        });
                      }}
                      color="primary"
                      checked={editedRows?.showItemInv?.find((item) => item.value === option.value) !== undefined}
                    />
                  </>
                }
                {option.label}
              </li>
            )}
          />
        </TableCell>
        <TableCell
          sx={{ outline: 'none !important' }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === 'Tab') {
              const element = document.getElementById('salesAccount');
              element?.focus();
            }
          }}
        >
          <Autocomplete
            tabIndex={0}
            openOnFocus
            fullWidth
            disableClearable
            id="purchaseAccount"
            name="purchaseAccount"
            disabled={editedRows?.purchaseInvoiceFlag === 1 ? false : true}
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            value={editedRows?.purchaseAccount}
            options={
              displayAllAccounts?.purchase
                ? [
                    'Add Purchase A/C',
                    ...allAccountArr.sort((a, b) => {
                      if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
                      if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
                      return 0;
                    }),
                    'Show All Accounts',
                  ]
                : [
                    'Add Purchase A/C',
                    ...purchaseArr.sort((a, b) => {
                      if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
                      if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
                      return 0;
                    }),
                    'Show All Accounts',
                  ]
            }
            size="small"
            onKeyDown={(e) => {
              let puchaseFlag = editedRows?.showItemInv?.some((ele) => ele.value === 1) ? 1 : 0;
              let salesFlag = editedRows?.showItemInv?.some((ele) => ele.value === 2) ? 1 : 0;
              const salesRows = [...sellingPriceRows];
              const purchaseRows = [...purchasePriceRows];
              const zeroSalesIndex = salesRows.findIndex((row) => row.amount === 0);
              const zeroPurchaseIndex = purchaseRows.findIndex((row) => row.amount === 0);
              const warMsg = ' Purchase Account  is required';
              const name = 'purchaseAccount';
              const currentId = 'purchaseAccount';
              const nextId = editedRows?.purchaseAccount?.value
                ? salesFlag === 0
                  ? registrationType !== 1
                    ? 'taxability'
                    : 'purchaseAmt'
                  : 'salesAccount'
                : 'purchaseAccount';

              const prevID = 'showItemInv';
              const required = true;
              handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID);
            }}
            onChange={(e, newValue) => {
              if (newValue?.value !== 'Add Purchase A/C') {
                setEditedRows((prev) => ({
                  ...prev,
                  purchaseAccount: newValue,
                }));
              }
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                border: 'none !important',
                outline: 'none !important',
                boxShadow: 'none !important',
                '&:hover': {
                  border: 'none !important',
                  outline: 'none !important',
                },
                '&.Mui-focused': {
                  border: 'none !important',
                  outline: 'none !important',
                  boxShadow: 'none !important',
                },
                '& fieldset': {
                  border: 'none !important',
                },
              },

              // Extra safety to remove outline from input itself
              '& .MuiOutlinedInput-input': {
                outline: 'none !important',
              },

              // Remove global focus-visible ring
              '&:focus-visible': {
                outline: 'none !important',
                boxShadow: 'none !important',
              },
              outline: 'none !important',
              width: '100%',
            }}
            PaperComponent={(props) => <CustomPaper {...props} />}
            renderInput={(params) => (
              <TextField
                required={editedRows.purchaseInvoice === 1 ? true : false}
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                {...params}
              />
            )}
            renderOption={(props, option) => (
              <>
                {option === 'Add Purchase A/C' ? (
                  <MenuItem
                    value={'addAccount'}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setOpenModalFlag(true);
                      setOpenPurchaseAccountModal(true);
                      setOpenSalesAccountModal(false);
                      setAccountType('Purchase');
                    }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'sticky',
                      width: '100%',
                      top: '-8px',
                      zIndex: '1',
                      backgroundColor: grey[50],
                      '&:hover': {
                        backgroundColor: grey[200],
                      },
                    }}
                  >
                    <AddBox
                      fontSize="small"
                      sx={{
                        marginRight: '5px',
                        color: 'primary.main',
                      }}
                    />
                    <ListItemText sx={{ color: 'primary.main' }} primary={'Add Purchase A/C'} />
                  </MenuItem>
                ) : option === 'Show All Accounts' ? (
                  <MenuItem
                    value={'showAllAccounts'}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'sticky',
                      bottom: '-7.5px',
                      bottom: '-8px',
                      mb: '-8px',
                      zIndex: 1,
                      ml: '-10px',
                      backgroundColor: grey[50],
                      '&:hover': {
                        backgroundColor: grey[200],
                      },
                    }}
                    onClick={(e) => {
                      setDisplayAllAccounts((prev) => ({
                        ...prev,
                        purchase: !displayAllAccounts?.purchase,
                      }));
                    }}
                  >
                    <Checkbox
                      checked={displayAllAccounts?.purchase}
                      fontSize="small"
                      sx={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '20px',
                        height: '20px',
                        color: 'primary.main',
                        verticalAlign: 'middle',
                      }}
                      onChange={(e) => {
                        e.stopPropagation();
                        if (e.target.checked == true) {
                          setDisplayAllAccounts((prev) => ({
                            ...prev,
                            purchase: true,
                          }));
                        } else {
                          setDisplayAllAccounts((prev) => ({
                            ...prev,
                            purchase: false,
                          }));
                        }
                      }}
                    />
                    <ListItemText sx={{ color: 'primary.main' }} primary={'Show All Accounts'} />
                  </MenuItem>
                ) : (
                  <MenuItem {...props} key={option.value} value={option.value}>
                    <ListItemText primary={option.label} />
                  </MenuItem>
                )}
              </>
            )}
          />
        </TableCell>
        <TableCell>
          <Autocomplete
            openOnFocus
            disableClearable
            fullWidth
            id="salesAccount"
            name="salesAccount"
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            disabled={editedRows.salesInvoiceFlag === 1 ? false : true}
            value={editedRows?.salesAccount}
            options={
              displayAllAccounts?.sales
                ? [
                    'Add Sales A/C',
                    ...allAccountArr?.sort((a, b) => {
                      if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
                      if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
                      return 0;
                    }),
                    'Show All Accounts',
                  ]
                : [
                    'Add Sales A/C',
                    ...salesArr?.sort((a, b) => {
                      if (a.label.toUpperCase() < b.label.toUpperCase()) return -1;
                      if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
                      return 0;
                    }),
                    'Show All Accounts',
                  ]
            }
            onKeyDown={(e) => {
              const purchaseFlag = editedRows?.showItemInv?.some((ele) => ele.value === 1) ? 1 : 0;
              const salesFlag = editedRows?.showItemInv?.some((ele) => ele.value === 2) ? 1 : 0;
            
              const salesRows = [...sellingPriceRows];
              const purchaseRows = [...purchasePriceRows];
            
              const zeroSalesIndex = salesRows.findIndex((row) => row.amount === 0);
              const zeroPurchaseIndex = purchaseRows.findIndex((row) => row.amount === 0);
            
              const warnMsg = 'Sales Account is required';
              const name = 'salesAccount';
              const currentId = 'salesAccount';
            
              const nextId =
                registrationType !== 1
                  ? 'taxability'
                  : purchaseFlag === 0
                  ? 'sellingprice'
                  : 'purchaseAmt';
            
              const prevId = purchaseFlag === 1 ? 'purchaseAccount' : 'showItemInv';
              const required = true;
            
              handleAutoCompleteKeyDown(e, currentId, nextId, required, warnMsg, prevId);
            }}
            
            size="small"
            onChange={(e, newValue) => {
              if (newValue?.value !== 'Add Sales A/C') {
                setEditedRows((prev) => ({
                  ...prev,
                  salesAccount: newValue,
                }));
              }
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                border: 'none !important',
                outline: 'none !important',
                boxShadow: 'none !important',
                '&:hover': {
                  border: 'none !important',
                  outline: 'none !important',
                },
                '&.Mui-focused': {
                  border: 'none !important',
                  outline: 'none !important',
                  boxShadow: 'none !important',
                },
                '& fieldset': {
                  border: 'none !important',
                },
              },

              // Extra safety to remove outline from input itself
              '& .MuiOutlinedInput-input': {
                outline: 'none !important',
              },

              // Remove global focus-visible ring
              '&:focus-visible': {
                outline: 'none !important',
                boxShadow: 'none !important',
              },
              outline: 'none !important',
              width: '100%',
            }}
            renderInput={(params) => (
              <TextField
                className={window.innerWidth > 1530 ? 'ToRightDrp' : ''}
                required={editedRows.salesInvoice === 1 ? true : false}
                sx={{
                  '.MuiFormLabel-asterisk': {
                    color: 'danger.main',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                {...params}
              />
            )}
            PaperComponent={(props) => <CustomPaper {...props} />}
            renderOption={(props, option) => (
              <>
                {option === 'Add Sales A/C' ? (
                  <MenuItem
                    value={'addAccount'}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      setOpenModalFlag(true);
                      setOpenSalesAccountModal(true);
                      setOpenPurchaseAccountModal(false);
                      setAccountType('Sales');
                    }}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'sticky',
                      width: '100%',
                      zIndex: '1',
                      top: '-10px',
                      mt: 0,
                      backgroundColor: grey[50],
                      '&:hover': {
                        backgroundColor: grey[200],
                      },
                    }}
                  >
                    <AddBox
                      fontSize="small"
                      sx={{
                        marginRight: '5px',
                        color: 'primary.main',
                      }}
                    />
                    <ListItemText sx={{ color: 'primary.main' }} primary={'Add Sales A/C'} />
                  </MenuItem>
                ) : option === 'Show All Accounts' ? (
                  <MenuItem
                    value={'showAllAccounts'}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      position: 'sticky',
                      bottom: '-7.5px',
                      bottom: '-8px',
                      mb: '-8px',
                      zIndex: 1,
                      ml: '-10px',
                      backgroundColor: grey[50],
                      '&:hover': {
                        backgroundColor: grey[200],
                      },
                    }}
                    onClick={(e) => {
                      setDisplayAllAccounts((prev) => ({
                        ...prev,
                        sales: !displayAllAccounts?.sales,
                      }));
                    }}
                  >
                    <Checkbox
                      checked={displayAllAccounts?.sales}
                      fontSize="small"
                      sx={{
                        marginLeft: '10px',
                        marginRight: '5px',
                        width: '20px',
                        height: '20px',
                        color: 'primary.main',
                        verticalAlign: 'middle',
                      }}
                      onChange={(e) => {
                        e.stopPropagation();
                        if (e.target.checked == true) {
                          setDisplayAllAccounts((prev) => ({
                            ...prev,
                            sales: true,
                          }));
                        } else {
                          setDisplayAllAccounts((prev) => ({
                            ...prev,
                            sales: false,
                          }));
                        }
                      }}
                    />
                    <ListItemText sx={{ color: 'primary.main' }} primary={'Show All Accounts'} />
                  </MenuItem>
                ) : (
                  <MenuItem {...props} key={option.value} value={option.value}>
                    <ListItemText primary={option.label} />
                  </MenuItem>
                )}
              </>
            )}
          />
        </TableCell>
        {getCompany?.relatedcompanydetailsnew?.[0].registrationtype != 1 && (
          <TableCell
            sx={{
              border: editedRows?.taxability?.value === '' && validStatus === false ? '3px solid #e55353 !important' : '',
            }}
          >
            <Autocomplete
              openOnFocus
              fullWidth
              disableClearable
              isOptionEqualToValue={(option, value) => option.value === value?.value}
              id="taxability"
              name="taxability"
              value={editedRows.taxability}
              disabled={editedRows.itemName === '' ? true : false}
              options={Taxability}
              size="small"
              onKeyDown={(e) => {
                const warMsg = 'Taxability is required';

                const currentId = 'taxability';
                const nextId =  'purchaseAmt';
                const prevID = 'salesAccount';
                const required = true;
                handleAutoCompleteKeyDown(e, currentId, nextId, required, warMsg, prevID);
              }}
              onChange={(e, newValue) => {
                let salesAmt = 0;
                let purchaseAmt = 0;
                let salesTaxableAmt = 0;
                let purchaseTaxableAmt = 0;
                if (sellingPriceRows?.length > 0) {
                  sellingPriceRows.map((ele) => {
                    if (ele.isActive === 1) {
                      salesAmt =companyType===3?ele?.amtaftdicount: ele.amountIncludingGst;
                      salesTaxableAmt = ele.amtaftdicount;
                    }
                  });
                }

                if (purchasePriceRows?.length > 0) {
                  purchasePriceRows.map((ele) => {
                    if (ele.isActive === 1) {
                      purchaseAmt = ele.amountIncludingGst;
                      purchaseTaxableAmt = ele.amtaftdicount;
                    }
                  });
                }

                setTaxableValue(newValue.value);
                if ([2, 3, 5, 7, 9].includes(newValue?.value) || getCompany?.relatedcompanydetailsnew?.[0].registrationtype == 1) {
                  setEditedRows((prev) => ({
                    ...prev,
                    registrationType: 1,
                    purchaseAmt: Number(purchaseTaxableAmt),
                    sellingprice: Number(salesTaxableAmt),
                  }));
                  setRegistrationType(1);
                } else {
                  setEditedRows((prev) => ({
                    ...prev,
                    registrationType: '',
                    purchaseAmt: Number(purchaseAmt),
                    sellingprice: [4].includes(newValue?.value) ? Number(salesTaxableAmt) : Number(salesAmt),
                  }));
                  setRegistrationType('');
                }
                setEditedRows((prev) => ({
                  ...prev,
                  taxability: newValue,
                }));
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  border: 'none !important',
                  outline: 'none !important',
                  boxShadow: 'none !important',
                  '&:hover': {
                    border: 'none !important',
                    outline: 'none !important',
                  },
                  '&.Mui-focused': {
                    border: 'none !important',
                    outline: 'none !important',
                    boxShadow: 'none !important',
                  },
                  '& fieldset': {
                    border: 'none !important',
                  },
                },

                // Extra safety to remove outline from input itself
                '& .MuiOutlinedInput-input': {
                  outline: 'none !important',
                },

                // Remove global focus-visible ring
                '&:focus-visible': {
                  outline: 'none !important',
                  boxShadow: 'none !important',
                },
                outline: 'none !important',
                width: '100%',
              }}
              PaperComponent={(props) => (
                <CustomPaper
                  {...props}
                  sx={{
                    width: '100%', // Match the width of the TableCell
                    minWidth: 'inherit', // Ensure it respects the TableCell's width
                    maxWidth: 'inherit', // Prevent overflow
                    ...props.sx, // Preserve any existing styles
                  }}
                />
              )}
              renderInput={(params) => (
                <TextField
                  sx={{
                    '.MuiFormLabel-asterisk': {
                      color: 'danger.main',
                      fontSize: '16px',
                      fontWeight: 'bold',
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...params}
                />
              )}
            />
          </TableCell>
        )}

        <TableCell
          align="righ"
          sx={{
            flexGrow: 1,
            minWidth: 100,
          }}
        >
          <span
            id="purchaseAmt"
            tabIndex="0"
            onKeyDown={(e) => {
              const warMsg = '';

              const currentId = 'purchaseAmt';
              const nextId = 'sellingprice';
              const prevID = 'taxability';
              const required = false;
              handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
            }}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              flexGrow: 1,
              minWidth: 100,
              outline: 'none !important',
            }}
          >
            <span style={{}}>{editedRows?.purchaseAccount?.value === '' ? '0.00' : MoneyFormatv3(editedRows.purchaseAmt)}</span>
            {editedRows?.purchaseInvoiceFlag === 1 && (
              <span style={{ marginLeft: 5 }}>
                <Tooltip title={editedRows?.itemId === '' ? 'Add' : 'Edit'} placement="right" disableInteractive arrow>
                  <IconButton
                    id="purchaseAmt"
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const element = document.getElementById('sellingprice');
                        element?.focus();
                      }
                    }}
                    disableRipple
                    aria-label="delete"
                    sx={{
                      margin: '0px 2px',
                      padding: '3px',
                      backgroundColor: editedRows?.itemId === '' ? '#83ff7b7a' : '#b1d1f97d',
                    }}
                    onClick={() => {
                      if (
                        (editedRows?.taxability?.value != 1 && editedRows?.taxability?.value != 4 && editedRows?.taxability?.value != '') ||
                        getCompany?.relatedcompanydetailsnew?.[0].registrationtype == 1
                      ) {
                        setRegistrationType(1);
                      } else {
                        setRegistrationType('');
                      }

                      if (editedRows?.itemId !== '') {
                        setParams({
                          id: editedRows?.itemId,
                          view: false,
                          salesFlag: editedRows?.salesInvoiceFlag,
                          purchaseFlag: editedRows?.purchaseInvoiceFlag,
                          taxType: editedRows.registrationType,
                        });
                      } else {
                        setParams({
                          id: '',
                          view: false,
                          salesFlag: 0,
                          purchaseFlag: 0,
                          taxType: '',
                        });
                      }
                      setOpenPriceModal(true);
                      setActiveRow(false);
                    }}
                  >
                    {editedRows?.itemId === '' ? (
                      <Add sx={{ fontSize: '18px', color: '#34994f' }} />
                    ) : (
                      <Edit sx={{ fontSize: '15px', color: '#6096d9' }} />
                    )}
                  </IconButton>
                </Tooltip>
              </span>
            )}{' '}
          </span>
        </TableCell>
        <TableCell
          align="right"
          sx={{
            flexGrow: 1,
            minWidth: 100,
          }}
        >
          <span
            id="sellingprice"
            tabIndex="0"
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              flexGrow: 1,
              minWidth: 100,
              outline: 'none !important',
            }}
            onKeyDown={(e) => {
              const warMsg = '';

              const currentId = 'sellingPrice';
              const nextId = 'Save';
              const prevID = 'purchaseAmt';
              const required = false;
              handleTextKeyDown(e, currentId, nextId, required, warMsg, prevID);
            }}
          >
            <span style={{}}>{editedRows?.salesAccount?.value === '' ? '0.00' : MoneyFormatv3(editedRows.sellingprice)}</span>
            {editedRows?.salesInvoiceFlag === 1 && (
              <span style={{ marginLeft: 5 }}>
                <Tooltip title={editedRows?.itemId === '' ? 'Add Price' : 'Edit Price'} placement="right" disableInteractive arrow>
                  <IconButton
                    id="sellingprice"
                    tabIndex="0"
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        const element = document.getElementById('Save');
                        element?.focus();
                      }
                    }}
                    disableRipple
                    aria-label="delete"
                    sx={{
                      margin: '0px 2px',
                      padding: '3px',
                      backgroundColor: editedRows?.itemId === '' ? '#83ff7b7a' : '#b1d1f97d',
                    }}
                    onClick={() => {
                      if (
                        (editedRows?.taxability?.value != 1 && editedRows?.taxability?.value != 4 && editedRows?.taxability?.value != '') ||
                        getCompany?.relatedcompanydetailsnew?.[0].registrationtype == 1
                      ) {
                        setRegistrationType(1);
                      } else {
                        setRegistrationType('');
                      }
                      if (editedRows?.itemId !== '') {
                        setParams({
                          id: editedRows?.itemId,
                          view: false,
                          salesFlag: editedRows?.salesInvoiceFlag,
                          purchaseFlag: editedRows?.purchaseInvoiceFlag,
                          taxType: editedRows.registrationType,
                        });
                      } else {
                        setParams({
                          id: '',
                          view: false,
                          salesFlag: 0,
                          purchaseFlag: 0,
                          taxType: '',
                        });
                      }
                      setOpenPriceModal(true);
                      setActiveRow(false);
                    }}
                  >
                    {editedRows?.itemId === '' ? (
                      <Add sx={{ fontSize: '15px', color: '#34994f' }} />
                    ) : (
                      <Edit sx={{ fontSize: '15px', color: '#6096d9' }} />
                    )}
                  </IconButton>
                </Tooltip>
              </span>
            )}{' '}
          </span>
          {/* </Typography> */}
        </TableCell>
        <TableCell
          align="center"
          // className={focusCell === "Action" ? clasess.focusTableCell : ""}
          className="actionBackGround"
          sx={{
            position: showActions ? 'sticky' : 'relative',
            width: 40,
            right: 0,
            backgroundColor: theme.palette.bodyGray.secondary,
            zIndex: 10,
            border: 'none !important',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              bottom: 0,
              width: '2px', // Adjust this value for the desired border thickness
              backgroundColor:
                //  isFocusItem
                //   ? "#9b6ab7"
                //   :
                'rgba(224, 224, 224, 1)', // Border color
              zIndex: 11, // Ensure it appears above the cell content
            },
          }}
        >
          <Box
            id="Save"
            tabIndex="0"
            sx={{
              width: 60,
              whiteSpace: 'nowrap',
              position: 'relative',
              left: '50%',
              transform: 'translate(-50%)',
              outline: 'none !important',
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === 'Tab') {
                saveChanges();
              }
            }}
          >
            <Tooltip title={'Save'} placement="right" disableInteractive arrow>
              <IconButton
                disableRipple={false}
                aria-label="delete"
                disabled={loading}
                sx={{
                  margin: '0px 2px',
                  padding: '5px',
                  backgroundColor: '#83ff7b7a',
                }}
                onClick={saveChanges}
              >
                <Done sx={{ fontSize: '15px', color: '#34994f' }} />
              </IconButton>
            </Tooltip>

            <Tooltip title={'cancel'} placement="right" disableInteractive arrow>
              <IconButton
                id="cancel"
                onClick={(event) => {
                  handleResetScroll();
                  setEditAble(false);
                  dispatch(setNavigationBlocked(false));
                  if (itemID === '') {
                    setAddEvent(false);
                  } else {
                    let arr = [...rows];
                    let tempArr = arr.filter((ele, index) => {
                      if (ele.new !== true) {
                        if (ele.itemId == editedRows.itemId) {
                          ele.editable = false;
                          ele.new = false;
                        }
                        return ele;
                      }
                    });
                    setRows(tempArr);
                  }
                }}
                aria-label="delete"
                sx={{
                  margin: '0px 2px',
                  padding: '5px',
                  backgroundColor: '#fbc7c78c',
                }}
                disableRipple={false}
              >
                <Close sx={{ fontSize: '15px', color: '#eb6a6a' }} />
              </IconButton>
            </Tooltip>
          </Box>
        </TableCell>
      </TableRow>
      {/* {openPriceModal === true && ( */}
      <PriceModal
        open={openPriceModal}
        setOpen={setOpenPriceModal}
        data={editedRows}
        todayDate={todayDate}
        sellingPriceRows={sellingPriceRows}
        setSellingPriceRows={setSellingPriceRows}
        editedSellingPriceRows={editedSellingPriceRows}
        setEditedSellingPriceRows={setEditedSellingPriceRows}
        tempSellingPriceRows={setEditedSellingPriceRows}
        setTempSellingPriceRows={setTempSellingPriceRows}
        purchasePriceRows={purchasePriceRows}
        setPurchasePriceRows={setPurchasePriceRows}
        editedPurchasePriceRows={editedPurchasePriceRows}
        setEditedPurchasePriceRows={setEditedPurchasePriceRows}
        tempPurchasePriceRows={tempPurchasePriceRows}
        setTempPurchasePriceRows={setTempPurchasePriceRows}
        setData={setEditedRows}
        params={params}
        setParams={setParams}
        setRegistrationType={setRegistrationType}
        registrationType={registrationType}
        setActiveRow={setActiveRow}
        activeRow={activeRow}
        priceTypeArr={priceTypeArr}
        setPriceTypeArr={setPriceTypeArr}
        priceTypeID={priceTypeID}
        setPriceTypeID={setPriceTypeID}
        setDeletedSalesRows={setDeletedSalesRows}
        setDeletedPurchaseRows={setDeletedPurchaseRows}
        previousID={previousID}
        setPreviousID={setPreviousID}
        taxableValue={taxableValue}
      />
      {/* )} */}
      {openMpdalFlag === true && (
        <AddItemsAccountModal
          open={accountType === 'Sales' ? openSalesAccountModal : openPurchaseAccountModal}
          setOpen={accountType === 'Sales' ? setOpenSalesAccountModal : setOpenPurchaseAccountModal}
          setData={setEditedRows}
          setAllAccount={accountType === 'Sales' ? setSalesArr : setPurchaseArr}
          accountType={accountType}
        />
      )}
      {openUnitModal === true && (
        <AddUnitsModal
          open={openUnitModal}
          setOpen={setUnitModal}
          setNewUnit={setNewUnit}
          uqcArray={uqcArrayList}
          setData={setEditedRows}
          currentUnit={editedRows?.unit}
          listData={() => getUnit('UNITS')}
        />
      )}
      {/* {openSettingsModal === true && ( */}
      <NewVoucherSettingsModal
        open={openSettingsModal}
        label="Item Code"
        type={editedRows.type == 1 ? 'Item' : 'Service'}
        setOpen={setOpenSettingsModal}
      />
      {/* )} */}
      {openHsnModal === true && (
        <AddHSNModal
          open={openHsnModal}
          setOpen={setOpenHsnModal}
          setData={setEditedRows}
          data={editedRows}
          setFilterHSN={setFilterHSN}
          filteredHSN={filterHSN}
          searchHSNSAC={() => searchHSNDetails('', 0, 20)}
          hsnParamsID={hsnParamsID}
          page={editedRows?.type === 1 ? 'GOODS' : 'SERVICE'}
          itemType={editedRows?.type === 1 ? 'GOODS' : 'SERVICE'}
        />
      )}
    </>
  );
}

export default AddNewItemRow;
